var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayout',{staticClass:"tour_shell"},[_vm._v("\n\t"+_vm._s(_vm.testProp)+"!?\n\t"),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }